<script>
  export let title;
  export let description = "No description specified";
  export let isDev = false;
  export let url = "#";
</script>

<a class="card h-100" target="_blank" href={url}>
  <div class="card-body p-4 py-5 text-center">
    <span class="avatar avatar-xl mb-4 rounded">{title.substr(0, 2)}</span>
    <h3 class="mb-0">{title}</h3>
    <p class="text-secondary">{description}</p>
    <p class="mb-3">
      {#if isDev}
        <span class="badge bg-purple-lt">Development Build</span>
      {:else}
        <span class="badge bg-blue-lt">Stable Release</span>
      {/if}
    </p>
  </div>
</a>
